import type { Conversation, Conversations } from '@/lib/types/chat';

export function setAndPushUrlProperty({ property, value }: { property: string; value: string }) {
  const url = new URL(window.location.toString());
  url.searchParams.set(property, value);
  window.history.pushState({}, '', url);
}

export function getChatHref(conversationId: string) {
  const params = new URLSearchParams({ id: conversationId });
  return `/chat?${params.toString()}`;
}

// The conversations store is metadata-only; message rows live in the
// ['conversation/messages', id] query cache. Server summaries can still carry
// a messages array — drop it so nothing re-introduces the field.
export function normalizeConversationSummaries(
  conversations: Conversations | null | undefined
): Conversations {
  if (!conversations || typeof conversations !== 'object') return {};

  return Object.fromEntries(
    Object.entries(conversations).map(([conversationId, conversation]) => {
      if (!conversation || !('messages' in conversation)) {
        return [conversationId, conversation];
      }

      const { messages: _messages, ...metadata } = conversation as Conversation & {
        messages?: unknown;
      };
      return [conversationId, metadata];
    })
  );
}
